module.exports = __webpack_public_path__ + "img/pinme.24d379cd.svg";